if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 768px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // RNT v437: Pomade product media no longer uses a story-play overlay.
        this.setupRntProductDesktopNavigation();
      }

      isRntMainProductPage() {
        const galleryProductUrl = (this.dataset.productUrl || '').replace(/\/$/, '');
        return [
          '/products/the-stiffy-texture-powder',
          '/products/rub-n-tug-pomades'
        ].includes(galleryProductUrl) || galleryProductUrl.includes('/products/beard-oil');
      }

      setupRntProductDesktopNavigation() {
        if (!this.isRntMainProductPage() || !this.elements.viewer || !this.elements.thumbnails) return;

        this.dataset.rntDesktopNav = 'true';

        if (!document.getElementById('rnt-product-desktop-nav-style')) {
          const style = document.createElement('style');
          style.id = 'rnt-product-desktop-nav-style';
          style.textContent = `
            @media (min-width: 992px) {
              media-gallery[data-rnt-desktop-nav="true"] { position:relative; }
              media-gallery[data-product-url="/products/the-stiffy-texture-powder"] .product__media-icon { display:none !important; }
              media-gallery[data-product-url="/products/the-stiffy-texture-powder"] .product__modal-opener { cursor:default !important; }
              media-gallery[data-rnt-desktop-nav="true"] .rnt-product-gallery-nav {
                position:absolute; top:0; bottom:auto; height:calc(100% - 105px); width:72px; z-index:50;
                border:0; padding:0; background:transparent; cursor:pointer;
                display:flex; align-items:center; opacity:0; transition:opacity .15s ease;
              }
              media-gallery[data-rnt-desktop-nav="true"]:hover .rnt-product-gallery-nav { opacity:1; }
              media-gallery[data-rnt-desktop-nav="true"] .rnt-product-gallery-prev { left:0; justify-content:flex-start; }
              media-gallery[data-rnt-desktop-nav="true"] .rnt-product-gallery-next { right:0; justify-content:flex-end; }
              media-gallery[data-rnt-desktop-nav="true"] .rnt-product-gallery-nav span {
                width:44px; height:44px; margin:14px; border-radius:50%; background:#fff; color:#000000;
                display:flex; align-items:center; justify-content:center; box-shadow:0 3px 14px rgba(0,0,0,.25);
                font:32px/1 Arial,sans-serif; pointer-events:none;
              }
            }
            @media (max-width: 991px) {
              media-gallery[data-rnt-desktop-nav="true"] .rnt-product-gallery-nav { display:none !important; }
            }
          `;
          document.head.appendChild(style);
        }

        const makeButton = (direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `rnt-product-gallery-nav rnt-product-gallery-${direction < 0 ? 'prev' : 'next'}`;
          button.setAttribute('aria-label', direction < 0 ? 'Previous product image' : 'Next product image');
          button.innerHTML = `<span aria-hidden="true">${direction < 0 ? '‹' : '›'}</span>`;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const thumbs = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
            if (!thumbs.length) return;
            let index = thumbs.findIndex((thumb) => thumb.querySelector('button[aria-current="true"]'));
            if (index < 0) {
              const active = this.elements.viewer.querySelector('[data-media-id].is-active');
              index = active ? thumbs.findIndex((thumb) => thumb.dataset.target === active.dataset.mediaId) : 0;
            }
            const nextIndex = (index + direction + thumbs.length) % thumbs.length;
            const nativeButton = thumbs[nextIndex].querySelector('button');
            if (nativeButton) nativeButton.click();
          });
          return button;
        };

        this.appendChild(makeButton(-1));
        this.appendChild(makeButton(1));

        // Preserve the original Stiffy-only no-zoom behavior. Pomade and Beard Oil keep native zoom/lightbox.
        if ((this.dataset.productUrl || '').replace(/\/$/, '') === '/products/the-stiffy-texture-powder') {
          this.elements.viewer.querySelectorAll('.product__modal-opener').forEach((opener) => {
            opener.addEventListener('click', (event) => {
              if (window.matchMedia('(min-width: 992px)').matches) {
                event.preventDefault();
                event.stopPropagation();
              }
            }, true);
          });
        }
      }

      isRntPomadePage() {
        // RNT v187: Quick View / Choose Options is rendered while the customer
        // is still on a collection or home page, so window.location.pathname
        // is not the product URL. Each gallery now identifies its own product.
        const galleryProductUrl = (this.dataset.productUrl || '').replace(/\/$/, '');
        return galleryProductUrl === '/products/rub-n-tug-pomades';
      }

      setupRntPomadeStoryTest() {
        if (!this.isRntPomadePage()) return;

        if (!document.getElementById('rnt-story-video-test-style')) {
          const style = document.createElement('style');
          style.id = 'rnt-story-video-test-style';
          style.textContent = `
            media-gallery .rnt-story-host { position: relative; }
            media-gallery .rnt-story-video-test {
              position:absolute; z-index:40; right:18px; top:18px;
              display:flex; align-items:center; gap:8px;
              border:2px solid #f15a24; border-radius:999px;
              background:rgba(0,0,0,.86); color:#fff;
              padding:10px 14px; cursor:pointer; box-shadow:0 3px 14px rgba(0,0,0,.28);
              font:inherit; line-height:1; -webkit-appearance:none; appearance:none;
            }
            media-gallery .rnt-play-triangle {
              display:inline-block; width:0; height:0; flex:0 0 auto;
              border-top:8px solid transparent;
              border-bottom:8px solid transparent;
              border-left:13px solid #f15a24;
            }
            media-gallery .rnt-story-video-test strong { font-size:12px; letter-spacing:.05em; white-space:nowrap; }
            /* RNT v186: replace Optimum's large centered full-size video play
               control with the same branded story language used on the variant
               hero. Thumbnail badges are untouched. */
            media-gallery .product__media-list deferred-media:not([loaded]) .deferred-media__poster-button {
              display:none !important;
            }
            media-gallery .product__media-list deferred-media:not([loaded]) .rnt-video-story-cue {
              position:absolute; z-index:5; right:18px; top:18px;
              display:flex; align-items:center; gap:8px;
              border:2px solid #f15a24; border-radius:999px;
              background:rgba(0,0,0,.86); color:#fff;
              padding:10px 14px; box-shadow:0 3px 14px rgba(0,0,0,.28);
              pointer-events:none; line-height:1;
            }
            
            media-gallery .product__media-list deferred-media:not([loaded]) .rnt-video-story-cue strong {
              font-size:12px; letter-spacing:.05em; white-space:nowrap;
            }
            @media (max-width: 749px) {
              media-gallery .rnt-story-video-test { right:12px; top:12px; padding:9px 12px; }
              media-gallery .rnt-story-video-test strong { font-size:11px; }
              media-gallery .product__media-list deferred-media:not([loaded]) .rnt-video-story-cue {
                right:12px; top:12px; padding:9px 12px;
              }
              media-gallery .product__media-list deferred-media:not([loaded]) .rnt-video-story-cue strong {
                font-size:11px;
              }
            }
          `;
          document.head.appendChild(style);
        }

        this.rntStoryButton = document.createElement('button');
        this.rntStoryButton.type = 'button';
        this.rntStoryButton.className = 'rnt-story-video-test';
        this.rntStoryButton.setAttribute('aria-label', 'Play pomade story video');
        this.rntStoryButton.innerHTML = '<span class=\"rnt-play-triangle\" aria-hidden=\"true\"></span><strong>PLAY THE STORY</strong>';
        this.rntStoryButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const videoSlide = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).find((slide) =>
            slide.querySelector('deferred-media, .deferred-media, video, iframe')
          );
          if (!videoSlide) return;

          this.setActiveMedia(videoSlide.dataset.mediaId, 'rnt-story');
        });

        const initialMedia = this.elements.viewer.querySelector('[data-media-id].is-active') ||
          this.elements.viewer.querySelector('[data-media-id]');
        this.mountRntStoryButton(initialMedia);
      }

      setupRntVideoStoryCues() {
        if (!this.isRntPomadePage()) return;

        this.elements.viewer.querySelectorAll('deferred-media:not([data-rnt-story-cue])').forEach((deferredMedia) => {
          const poster = deferredMedia.querySelector('.deferred-media__poster');
          if (!poster) return;

          const cue = document.createElement('span');
          cue.className = 'rnt-video-story-cue';
          cue.setAttribute('aria-hidden', 'true');
          cue.innerHTML = '<span class="rnt-play-triangle" aria-hidden="true"></span><strong>PLAY THE STORY</strong>';
          poster.appendChild(cue);
          deferredMedia.dataset.rntStoryCue = 'true';
        });
      }

      pauseRntInactiveVideos(activeItem) {
        if (!this.isRntPomadePage()) return;
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((slide) => {
          if (slide === activeItem) return;
          slide.querySelectorAll('video').forEach((video) => {
            try {
              video.pause();
              video.currentTime = 0;
            } catch (error) {}
          });
          slide.querySelectorAll('.js-youtube').forEach((iframe) => {
            try { iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (error) {}
          });
          slide.querySelectorAll('.js-vimeo').forEach((iframe) => {
            try { iframe.contentWindow.postMessage('{"method":"pause"}', '*'); } catch (error) {}
          });
        });
      }

      mountRntStoryButton(mediaItem) {
        if (!this.isRntPomadePage() || !this.rntStoryButton || !mediaItem) return;
        if (mediaItem.querySelector('deferred-media, .deferred-media, video, iframe')) return;

        this.elements.viewer.querySelectorAll('.rnt-story-host').forEach((item) => item.classList.remove('rnt-story-host'));
        mediaItem.classList.add('rnt-story-host');
        mediaItem.appendChild(this.rntStoryButton);
      }
      // onSlideChanged(event) {
      //   if (event.detail && event.detail.currentElement) {
      //     const currentElement = event.detail.currentElement;
      //     if (currentElement.dataset && currentElement.dataset.mediaId) {
      //       const thumbnail = this.elements.thumbnails.querySelector(
      //         `[data-target="${currentElement.dataset.mediaId}"]`
      //       );
      //       this.setActiveThumbnail(thumbnail);
      //     }
      //   }
      // }
      onSlideChanged(event) {
        if (event.detail && event.detail.currentElement) {
          const currentElement = event.detail.currentElement;
          this.pauseRntInactiveVideos(currentElement);
          if (currentElement.dataset && currentElement.dataset.mediaId) {
            // Prevent resetting to the first image if a variant was selected
            if (this.elements.viewer.dataset.selectedMediaId && 
                this.elements.viewer.dataset.selectedMediaId !== currentElement.dataset.mediaId) {
                return;
            }
            const thumbnail = this.elements.thumbnails.querySelector(
                `[data-target="${currentElement.dataset.mediaId}"]`
            );
            this.setActiveThumbnail(thumbnail);
          }
        }
      }
      
      setActiveMedia(mediaId, action) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.pauseRntInactiveVideos(activeMedia);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        // Variant changes arrive from product-info.js with action === true.
        // Thumbnail clicks pass a MouseEvent. The story button uses 'rnt-story'.
        // Only a real variant change moves the story button onto the new hero image.
        if (action === true) this.mountRntStoryButton(activeMedia);

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            if (action === 'rnt-story') {
              const slider = activeMedia.parentElement;
              const oldScrollBehavior = slider.style.scrollBehavior;
              slider.style.scrollBehavior = 'auto';
              slider.scrollLeft = activeMedia.offsetLeft;
              window.requestAnimationFrame(() => { slider.style.scrollBehavior = oldScrollBehavior; });
            } else {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        // RNT v185 test: on the Pomade page, selecting a normal video
        // thumbnail should show its clean poster first instead of immediately
        // instantiating the native video player/controls. A tap on the poster
        // still loads the video through Optimum's existing DeferredMedia code.
        // The custom PLAY THE STORY action keeps the instant-load behavior.
        const rntCleanVideoPreview =
          this.isRntPomadePage() &&
          action !== 'rnt-story' &&
          activeMedia.querySelector('deferred-media');

        if (rntCleanVideoPreview) {
          window.pauseAllMedia();
        } else {
          this.playActiveMedia(activeMedia);
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }
        this.elements.viewer.dataset.selectedMediaId = mediaId;
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.setSlidePosition(thumbnail[this.elements.thumbnails.offsetLeft]);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
